<template>
  <div class="menu-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <div v-if="item.uuid==''" >
                <i className="fa fa-align-justify"></i><strong>{{ $t('common.create') }}</strong>
              </div>
              <div v-if="item.uuid!=''" >
                <i className="fa fa-align-justify"></i><strong>{{ $t('common.edit') }}</strong>
              </div>
            </div>
            <b-form class="row" v-if="item != null">
              <b-col cols="6">
                <b-form-group v-bind:label="$t('permission.name')" :label-cols="3" :horizontal="true">
                  <b-form-input
                    class="form-control"
                    v-model="item.name"
                    :state="!$v.item.name.$invalid"
                    :aria-describedby="'name-feedback'" />
                  <b-form-invalid-feedback :id="'name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group v-bind:label="$t('permission.slug')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control"
                                v-model="item.slug"
                                :state="!$v.item.slug.$invalid"
                                :aria-describedby="'name-feedback'" />
                  <b-form-invalid-feedback :id="'name-feedback'">
                    {{ $t('message.required_filed') }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-col>

            </b-form>
            <div slot="footer">
              <div class="text-center">
                <b-button variant="default" v-on:click="$router.go(-1)" ><i class="fa fa-arrow-left"></i>&nbsp; {{$t('common.back')}}</b-button>
                <b-button variant="success" v-on:click="savePermission()" :disabled="checkSubmit()" ><i class="fa fa-arrow-right"></i>&nbsp; {{$t('common.save')}}</b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue, email, decimal, or, numeric } from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  let vm = null

  export default {
    name: 'PermissionForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      Tables,
      cSwitch,
    },
    data: function () {
      return {
        item: {
          name: '',
          slug: ''
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        },
        slug: {
          required
        }
      }
    },
    methods: {
      checkSubmit: function(){
        return vm.$v.item.$invalid
      },
      isJSON: function(str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      /**
       * upload image then move to next form
       */
      savePermission() {
        let item = JSON.parse(JSON.stringify(vm.item))
        // call an API to save client information
        // check create or update
        if (vm.uuid == 'create' || vm.uuid == undefined) {
          vm.axios.tenant.createPermission(item, function(response){
            vm.$router.push({name: 'permission_list'})
          })
        }
        else{ // update permission
          delete item['uuid']
          delete item['created_at']
          delete item['updated_at']
          vm.axios.user.updatePermission(vm.uuid, item, function(response){
            vm.$router.push({name: 'permission_list'})
          }, error => {
            console.log('error', error)
          })
        }
      },
    },
    created: function () {
      vm = this
    },
    mounted: function () {
      if (vm.uuid == 'create' || vm.uuid == undefined) {
      }
      else{
        vm.axios.user.getPermissionDetail(vm.uuid, function(response){
          let item = JSON.parse(JSON.stringify(response.data.data.item))

          vm.item = item
        })
      }
    }
  }
</script>

<style scoped>
  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .custom-checkbox {
    padding-left: 0px;
  }

  .col-6{
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/permissions/BaseForm.vue